import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getConsentTypes = store => store[NAME].consentTypes;
export const getColaborators = store => store[NAME].colaborators;
export const getBenefitConsent = store => store[NAME].benefitConsent;